export default __webpack_public_path__ + "static/media/banner.528cfc21.jpg";